
// import helperMixin
import helperMixin from './helperMixin.js';
window.vueApp.mixin(helperMixin);

// VueMasonryWall
import MasonryWall from '@yeger/vue-masonry-wall';
window.vueApp.use(MasonryWall);

